/* eslint-disable no-unused-vars */
import React, { useContext, useState, useRef, useMemo } from 'react'
import { Button, message, Select, Input, Tabs, Tag, Empty } from 'antd'
import {
  getApiTargetInfo,
  getEnvConfig,
  ExportComponent,
  UnitSelection,
} from 'core'
import { connect } from 'react-redux'
import R from 'ramda'
import MisoVerificationDialog from './MisoVerificationDialog'
import {
  CriteriaRow,
  Title,
  Content,
  FullHeightSizer,
  Filler,
} from 'core/screen-util'
import {
  rowHeaderRender,
  exportDataComponent,
  hasAccesPermits,
  sortStringArray,
} from 'core/utils'
import {
  UnitSelectionContext,
  SpinContext,
  ErrorContext,
  JcTmpErrorContext,
} from 'context'
import {
  getUtilityNameMap,
  getUnitNameMap,
  getUtilityUnitsMap,
  getUnits,
  getCauseCodeMap,
  isUnitLoading,
  getAmlificationCode,
  getFailCode,
  getPermitActions,
  isAdminType,
} from 'core/selectors'
import { Label } from '../core/screen-util'
import StatisticsGraphs from './StatisticsGraph'
import StatisticsGraphTtoal from './StatisticsGraphTotal'
import moment from 'moment'

import {
  HeaderRowHeightVerification,
  MisoVerificationTestHeaders,
} from './Utils'
import { Grid, virtualizedGridRenderer } from '@integec/grid-tools'
import { getMisoVerificationTest } from 'api/pgads'

const NetCapVerificationSummary = props => {
  const {
    unitNameMap,
    utilityNameMap,
    apiTargetInfo,
    yearSelection = [],
  } = props
  const curYear = parseInt(moment().format('YYYY'))

  const { selectedUnits, setVisibleUnitSelection } = useContext(
    UnitSelectionContext
  )
  const { setError } = useContext(ErrorContext)
  const { spinning, setSpinning } = useContext(SpinContext)
  const { setTmpError } = useContext(JcTmpErrorContext)

  const [year, setYear] = useState(curYear)
  // const [season, setSeason] = useState('S')

  const [data, setData] = useState([])

  const [fuzzyFilter, setFuzzyFilter] = useState('')
  const [selected, setSelected] = useState({})
  const [showEditDialog, setShowdialogData] = useState(false)
  const [isRetrieved, setISRetrieved] = useState(false)
  const onCriteriaChnage = _ => {
    setData([])
    setISRetrieved(false)
  }

  const onRetrieve = _ => {
    if (selectedUnits.length <= 0) {
      message.warn('Please,select Unit(s)')
      setVisibleUnitSelection(true)
      return
    }
    const cr = { unitId: selectedUnits.map(u => u.unitId), year }
    setSpinning(true)
    getMisoVerificationTest(apiTargetInfo)(cr).fork(setError, data => {
      setSpinning(false)
      setISRetrieved(true)
      setData(data)
    })
  }

  const GridRef = useRef()

  const headerWithFormatter = useMemo(
    _ =>
      MisoVerificationTestHeaders.map(h =>
        h.ident === 'utility'
          ? {
              ...h,
              // ...toSelectionColProps(utilityNameMap),
              dataFormatter: ({ value }) => utilityNameMap[value] || value,
              sortIndexGetter: ({ rowData }) =>
                utilityNameMap[rowData.utility] || rowData.utility,
            }
          : h.ident === 'unitId'
          ? {
              ...h,
              // dataGetter: generateDataGetter,
              dataFormatter: ({ value }) => unitNameMap[value] || value,
              sortIndexGetter: ({ rowData }) =>
                unitNameMap[rowData.unitId] || rowData.unitId,
            }
          : h
      ),
    [unitNameMap, utilityNameMap]
  )
  const title = 'Net Cap Verification Summary'
  const [visible, setVisible] = useState(false)

  const avaDataUnits = data.map(d => d.unitId)
  const allDataUnit = selectedUnits.map(d => d.unitId)

  const notAvalDAta = R.uniq(allDataUnit.filter(u => !avaDataUnits.includes(u)))
  const [selTab, setSelTab] = useState('Tested')

  const misoYear = R.range(0, 16)
    .map(i => curYear - i)
    .filter(year => year > 2022)
  const yearSelect = yearSelection.length <= 0 ? misoYear : yearSelection

  return (
    <React.Fragment>
      <UnitSelection setData={_ => setData([])} />
      <CriteriaRow>
        <Title>{title}</Title>
        <Label style={{ marginLeft: 50 }}>Year : </Label>
        <Select
          value={year}
          onChange={year => {
            setYear(year)
            onCriteriaChnage()
          }}
          style={{ marginLeft: 10 }}
        >
          {yearSelect.map(y => (
            <Select.Option key={y} value={y}>
              {y}
            </Select.Option>
          ))}
        </Select>
        {/* <Label>Season : </Label>
        <Select value={season} onChange={setSeason}>
          <Select.Option key="S" value="S">
            Summer
          </Select.Option>
          <Select.Option key="W" value="W">
            Winter
          </Select.Option>
        </Select> */}

        <Button
          loading={spinning}
          onClick={onRetrieve}
          style={{ marginLeft: '10px' }}
          type="primary"
          icon="database"
        >
          Retrieve
        </Button>
        <Button
          loading={spinning}
          onClick={_ => {
            if (Object.keys(selected || {}).length <= 0) {
              message.info('Please, Select Row')
              return
            }

            setVisible(true)
          }}
          style={{ marginLeft: '10px' }}
          type="primary"
          icon="database"
        >
          View Record
        </Button>
        <Filler />
        <Input.Search
          placeholder="Filter"
          value={fuzzyFilter}
          style={{
            marginLeft: '10px',
            marginRight: '10px',
            flex: '0 0 200px',
          }}
          onChange={e => setFuzzyFilter(e.target.value)}
        />
        {/* <ExportComponent
          getData={_ => exportDataComponent(GridRef, data, fuzzyFilter)}
          data={data}
          headers={(MisoVerificationTestHeaders || []).map(d => ({
            ...d,
            rowHeaderBackgroundColor: '#eee',
          }))}
          fileName={title}
          btnStyle={{ marginRight: '10px' }}
          disabled={data.length <= 0}
        /> */}
      </CriteriaRow>
      <CriteriaRow
        style={{
          marginTop: 5,
          paddingTop: 5,
          gap: 5,
          display: isRetrieved ? 'grid' : 'none',
          gridTemplateColumns: 'min-content auto',
          gridTemplateRows: 'auto',
        }}
      >
        <fieldset
          style={{
            display: 'grid',
            gridTemplateColumns: '100px 30px 200px',
            gap: 5,
            border: '1px solid grey',
          }}
        >
          <legend style={{ width: 100 }}>Statistics :</legend>
          <div>Tested Units : </div>
          <div>
            {R.compose(
              R.length,
              R.uniq,
              R.map(d => d.unitId)
            )(data)}
          </div>
          <div>
            <StatisticsGraphs
              total={selectedUnits.length}
              value={selectedUnits.length - notAvalDAta.length}
              color="lightgreen"
            />
          </div>
          <div>Pending Units : </div>
          <div>{notAvalDAta.length}</div>
          <div>
            <StatisticsGraphs
              total={selectedUnits.length}
              value={notAvalDAta.length}
            />
          </div>
          <div>Total Units : </div>
          <div>{selectedUnits.length}</div>
          <div>
            <StatisticsGraphTtoal
              total={selectedUnits.length}
              value={notAvalDAta.length}
            />
          </div>
        </fieldset>
        <fieldset
          style={{
            border: '1px solid grey',
            height: '100%',
            width: '100%',
            display: 'flex',
            flexWrap: 'wrap',
            overflowY: 'auto',
            justifyContent: 'flex-start',
            alignContent: 'flex-start',
            gap: '3px',
            maxHeight: '140px',
          }}
        >
          <legend style={{ width: 130 }}>Remaining :</legend>
          {sortStringArray(notAvalDAta.map(t => unitNameMap[t] || t)).map(t => (
            <Tag key={t}>{t}</Tag>
          ))}
        </fieldset>
      </CriteriaRow>
      <FullHeightSizer heightOffset={400}>
        {({ height, width }) => (
          <Content style={{ height: height - 20 }}>
            {/* <Tabs activeKey={selTab} onChange={setSelTab}>
              <Tabs.TabPane tab="Tested" key="Tested">
                <div style={{ height: height - 10, width }}> */}
            <Grid
              ref={GridRef}
              // editMode="cell"
              data={data || []}
              headers={headerWithFormatter}
              altBy={o => o.unitId}
              altBgColor="#ebebeb"
              render={virtualizedGridRenderer({
                autoFixColByKey: true,
                rowHeaderRender,
                height: height - 40,
                width: width - 50,
                headerRowHeight: HeaderRowHeightVerification,
              })}
              fuzzyFilter={fuzzyFilter}
              onSelectionChange={({ selectedRows }) => {
                setSelected(selectedRows[0])
              }}
              initialSortOptions={MisoVerificationTestHeaders}
              sortOptions={MisoVerificationTestHeaders}
              sortEnabled
              isEditable={false}
              selectionType="row"
              selectionMode="single"
            />
            {/* </div>
              </Tabs.TabPane>
              <Tabs.TabPane tab="Pending" key="Pending">
                <div>
                  
                </div>
              </Tabs.TabPane>
            </Tabs> */}
          </Content>
        )}
      </FullHeightSizer>
      {visible && (
        <MisoVerificationDialog
          insertdata={selected}
          unitNameMap={props.unitNameMap}
          utilityNameMap={utilityNameMap}
          visible={visible}
          setVisible={_ => {
            setVisible(false)
            setSelected({})
          }}
          apiTargetInfo={props.apiTargetInfo}
          setError={setError}
          setTmpError={setTmpError}
        />
      )}
    </React.Fragment>
  )
}

// const getXeforlData = (selected = {}, exfordDataList = []) => {
//   const found = exfordDataList.find(
//     x =>
//       x.unitId === selected.unitId &&
//       x.year === selected.year &&
//       x.period === selected.period &&
//       x.testIdx === selected.testIdx
//     // &&      x.standard === selected.standard
//   )

//   return found
// }

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
  utilityUnitMap: getUtilityUnitsMap(state),
  units: getUnits(state),
  actionPermits: getPermitActions(state),
  envConfig: getEnvConfig(state),
  isAdminType: isAdminType(state),
})

export default connect(mapStateToProps)(NetCapVerificationSummary)
